// mcn-frontend/src/components/auth/Login.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../contexts/UserContext';
import './Auth.css';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useUser();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch('/api/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (response.ok) {
        // Store token and tenant info
        localStorage.setItem('token', data.token);
        
        // Store tenant information if available
        if (data.user.tenant) {
          localStorage.setItem('tenantId', data.user.tenant.id);
          localStorage.setItem('tenantName', data.user.tenant.name);
        }
        
        // Update user context with full user data including tenant
        login(data.user);
        
        // Enhanced role-based routing
        switch(data.user.role) {
          case 'SUPER_ADMIN':
            navigate('/super-admin-dashboard');
            break;
          case 'ADMIN':
            navigate('/admin-dashboard');
            break;
          case 'MANAGER':
            navigate('/manager-dashboard');
            break;
          case 'FINANCE_MANAGER':
            navigate('/finance-dashboard');
            break;
          case 'CONTENT_MANAGER':
            navigate('/content-moderation');
            break;
          case 'AGGREGATOR':
            navigate('/aggregator-dashboard');
            break;
          case 'CHANNEL_OWNER':
            navigate('/channel-dashboard');
            break;
          case 'CREATOR':
          case 'CONTENT_CREATOR':
            navigate('/creator-dashboard');
            break;
          case 'STUDIO':
            navigate('/studio-dashboard');
            break;
          case 'INVESTOR':
          case 'PREMIUM_INVESTOR':
            navigate('/investor-dashboard');
            break;
          case 'SUPPORT_AGENT':
            navigate('/support-dashboard');
            break;
          case 'ANALYTICS_VIEWER':
            navigate('/analytics-dashboard');
            break;
          default:
            navigate('/dashboard');
        }
      } else {
        setError(data.error || 'Login failed');
      }
    } catch (err) {
      setError('Network error. Please try again.');
      console.error('Login error:', err);
    } finally {
      setLoading(false);
    }
  };

  // Quick login buttons for development
  const quickLogin = (email, password) => {
    setFormData({ email, password });
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Login to Choice Network</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="Enter your email"
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              placeholder="Enter your password"
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          <button type="submit" disabled={loading} className="btn-primary">
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
        
        {/* Development Quick Login - Remove in Production */}
        {process.env.NODE_ENV === 'development' && (
          <div className="quick-login-dev" style={{ marginTop: '20px', padding: '10px', border: '1px dashed #ccc' }}>
            <p style={{ fontSize: '12px', color: '#666' }}>Quick Login (Dev Only):</p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px', marginTop: '10px' }}>
              <button 
                type="button"
                onClick={() => quickLogin('superadmin@choicenetwork.com', 'admin123')}
                style={{ fontSize: '11px', padding: '5px 10px' }}
              >
                Super Admin
              </button>
              <button 
                type="button"
                onClick={() => quickLogin('manager@choicenetwork.in', 'password123')}
                style={{ fontSize: '11px', padding: '5px 10px' }}
              >
                Manager
              </button>
              <button 
                type="button"
                onClick={() => quickLogin('aggregator.mumbai@choicenetwork.in', 'password123')}
                style={{ fontSize: '11px', padding: '5px 10px' }}
              >
                Aggregator
              </button>
              <button 
                type="button"
                onClick={() => quickLogin('healthyliving365@choicenetwork.in', 'password123')}
                style={{ fontSize: '11px', padding: '5px 10px' }}
              >
                Channel Owner
              </button>
              <button 
                type="button"
                onClick={() => quickLogin('raj_creator@creator.com', 'password123')}
                style={{ fontSize: '11px', padding: '5px 10px' }}
              >
                Creator
              </button>
              <button 
                type="button"
                onClick={() => quickLogin('amit_investor@investor.com', 'password123')}
                style={{ fontSize: '11px', padding: '5px 10px' }}
              >
                Investor
              </button>
            </div>
          </div>
        )}
        
        <p className="auth-link">
          Don't have an account? <a href="/register">Register here</a>
        </p>
      </div>
    </div>
  );
};

export default Login;